import React from 'react';
import classNames from 'classnames';
import { DialogTitleComponentProps } from './DialogTitle';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import './DialogTitleRoot.less';

interface IDialogTitleRootProps extends DialogTitleComponentProps {
  className?: string;
  children: React.ReactNode;
}

export const DialogTitleRoot = React.forwardRef((props: IDialogTitleRootProps, ref) => {
  const rootClasses = classNames('dp-dialog-title-root', props.className, props.classes?.root);
  return (
    <MuiDialogTitle
      ref={ref}
      id={props.draggableId}
      disableTypography
      className={rootClasses}
      style={{ ...(props.styles?.root || {}), cursor: !props.isFullScreen ? 'move' : undefined }}
    >
      {props.children}
    </MuiDialogTitle>
  );
});
